<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 ref="tituloRef" class="poster-title">Itinerario</h2>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" alt="" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Ceremonia Religiosa',
        hora: '7:00 PM',
        icono: require('@/assets/og.png')
      },
      {
        nombre: 'Recepción',
        hora: '8:00 PM',
        icono: require('@/assets/copa.png')
      },
          {
        nombre: 'Cena',
        hora: '9:00 PM',
        icono: require('@/assets/cen.avif')
      },
   
      {
        nombre: 'Fiesta',
        hora: '8:00 PM - 1:00 AM',
        nota: 'A disfrutar la fiesta!',
        icono: require('@/assets/cel.avif')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)
    const tituloRef = ref(null)
    let ctx = null

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        // ------------------------------------
        // ANIMACIÓN DEL TÍTULO (Se dispara en 'top 75%')
        // ------------------------------------
        gsap.fromTo(
          tituloRef.value,
          {
            opacity: 0,
            y: 35,
            letterSpacing: '6px',
            filter: 'blur(6px)'
          },
          {
            opacity: 1,
            y: 0,
            letterSpacing: '2px',
            filter: 'blur(0px)',
            duration: 1.4,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: tituloRef.value,
              start: 'top 75%', // Requiere entrar más a la pantalla para arrancar
              toggleActions: 'play none none none',
              once: true
            }
          }
        )

        // ------------------------------------
        // VARIACIONES DE ENTRADA ÚNICAS PARA CADA ELEMENTO
        // ------------------------------------
        const animProps = [
          { iconFrom: { y: 40, rotation: -8, scale: 0.85 }, textFrom: { y: 25, x: -10 } },
          { iconFrom: { x: -45, rotation: 10, scale: 0.88 }, textFrom: { x: 25, y: 15 } },
          { iconFrom: { scale: 0.75, rotationY: 45 }, textFrom: { y: 30, scale: 0.95 } },
          { iconFrom: { x: 45, rotation: -12, scale: 0.85 }, textFrom: { x: -20, y: 15 } }
        ]

        // ------------------------------------
        // ANIMACIONES CONSECUTIVAS INDIVIDUALES POR ITEM
        // ------------------------------------
        itemRefs.value.forEach((el, index) => {
          if (!el) return

          const icon = el.querySelector('.poster-icon')
          const text = el.querySelector('.poster-text')
          const config = animProps[index % animProps.length]

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: el,
              start: 'top 72%', // Ajustado estrictamente para activarse solo al llegar con el scroll
              toggleActions: 'play none none none',
              once: true
            }
          })

          // 1. Icono entra flotando con desenfoque fino y rotación suave
          tl.fromTo(
            icon,
            {
              opacity: 0,
              filter: 'blur(5px)',
              ...config.iconFrom
            },
            {
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotation: 0,
              rotationY: 0,
              filter: 'blur(0px)',
              duration: 1.3,
              ease: 'back.out(1.2)'
            }
          )
          // 2. Texto aparece justo después con desenfoque y desplazamiento
          .fromTo(
            text,
            {
              opacity: 0,
              filter: 'blur(4px)',
              ...config.textFrom
            },
            {
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              filter: 'blur(0px)',
              duration: 1.2,
              ease: 'power2.out'
            },
            '-=0.9'
          )
        })

        // Recalcular posiciones exactas de scroll una vez cargado el DOM
        setTimeout(() => {
          ScrollTrigger.refresh()
        }, 300)

      }, sectionRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { eventos, itemRefs, sectionRef, tituloRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  overflow: hidden;
  padding: 60px 20px 80px;
  text-align: center;
  position: relative;
  perspective: 1000px;

  /* FONDO BASE */
background-color:
    #f0c9d3;
}

/* ==================== SOMBRAS Y REFLEJOS DE AGUA CÁUSTICA ==================== */

.itinerario-poster::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  
  
  
  filter: blur(12px);
  pointer-events: none;
  z-index: 1;
  mix-blend-mode: multiply;
  animation: distorsionAgua 12s ease-in-out infinite alternate;
}

.itinerario-poster::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  background: repeating-linear-gradient(
    -35deg,
    transparent 0%,
    rgba(255, 255, 255, 0.25) 15%,
    transparent 30%
  );
  
  filter: blur(8px);
  pointer-events: none;
  z-index: 1;
  mix-blend-mode: overlay;
  animation: brilloSuperficie 8s ease-in-out infinite alternate;
}

@keyframes distorsionAgua {
  0% {
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  50% {
    transform: translate(-3%, 2%) rotate(2deg) scale(1.05);
  }
  100% {
    transform: translate(2%, -3%) rotate(-1deg) scale(0.98);
  }
}

@keyframes brilloSuperficie {
  0% {
    opacity: 0.3;
    transform: translateY(-2%);
  }
  100% {
    opacity: 0.7;
    transform: translateY(2%);
  }
}

/* ===== SOMBRA EDITORIAL PROFUNDA PARA EL TÍTULO ===== */
.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #2c2929;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.8),
    0 4px 15px rgba(0, 0, 0, 0.18);
  will-change: transform, opacity, filter, letter-spacing;
}

.poster-item {
  margin-bottom: 42px;
  position: relative;
  z-index: 2;
  will-change: transform;
}

/* ===== SOMBRA DE GOTA Y REALCE EN ICONOS ===== */
.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
  filter: 
    drop-shadow(0 8px 16px rgba(0, 0, 0, 0.22))
    drop-shadow(0 2px 4px rgba(255, 255, 255, 0.6));
  will-change: transform, opacity, filter;
  transform-style: preserve-3d;
}

/* ===== SOMBRAS MULTINIVEL DE ALTA LEGIBILIDAD PARA EL TEXTO ===== */
.poster-text {
  font-family: 'Playfair Display', serif;
  color: #1c1b1b;
  line-height: 1.4;
  text-shadow: 
    0 1px 2px rgba(255, 255, 255, 0.9),
    0 3px 12px rgba(0, 0, 0, 0.2);
  will-change: transform, opacity, filter;
}

.evento-nombre {
  display: block;
  font-size: 23px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
  color: #383535;
  font-weight: 500;
}

.evento-nota {
  display: block;
  font-size: 15px;
  font-style: italic;
  margin-top: 6px;
  color: #555151;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  overflow: visible;
  background-color: #f0c9d3;
    z-index: 5;
  pointer-events: none;
}

.rasgado-top {
  background:
    radial-gradient(ellipse at 50% 20%, rgba(240, 230, 230, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;

  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  overflow: visible;
  background:
    radial-gradient(ellipse at 50% 20%, rgba(255, 255, 255, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;

  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}
</style>